module.exports = __webpack_public_path__ + "static/media/candidate-hired.09998682.png";